var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInbox = function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#inbox_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.859 14.664H2.14c-.814 0-1.474.66-1.474 1.474v19.72c0 .814.66 1.473 1.474 1.473h33.719c.814 0 1.474-.66 1.474-1.474V16.138c0-.814-.66-1.474-1.474-1.474Z",
    fill: "#B93CE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-.09 37.33H39.7L19 25.992-.09 37.33ZM18.266 25.544 1.246 14.97 18.111 1.608a1.51 1.51 0 0 1 1.811.044l16.904 13.369-17.05 10.509a1.467 1.467 0 0 1-1.511.014Z",
    fill: "#8A1EBC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "inbox_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 36,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.265 25.544 1.245 14.97 18.11 1.608a1.51 1.51 0 0 1 1.811.044l16.903 13.369-17.05 10.509a1.467 1.467 0 0 1-1.51.014Z",
    fill: "#8A1EBC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#inbox_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12 20.832a3.865 3.865 0 0 1 3.57-2.933c1.145-.161 2.45 0 3.33-.733 1.1-.954.866-2.824 1.848-3.887.865-.946 2.34-.931 3.608-.733 1.269.198 2.662.403 3.755-.272 1.092-.674 1.51-2.082 1.576-3.373a17.59 17.59 0 0 1 .155-2.853 3.733 3.733 0 0 1 2.148-2.852c1.188-.426 1.84-.367 2.728.49a4.862 4.862 0 0 1 1.159 2.516c.733 3.264.58 6.644.88 9.974.33 3.666 1.166 7.48-.073 10.94a10.714 10.714 0 0 1-6.6 6.806 20.886 20.886 0 0 1-10.18.624 11.543 11.543 0 0 1-4.51-1.467 8.69 8.69 0 0 1-3.52-5.507 17.395 17.395 0 0 1 .125-6.74Z",
    fill: "#FF8257"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 12.4c1.554 1.15 3.036 2.427 4.473 3.732l1.57 1.467a.19.19 0 0 0 .322-.154c-.044-.39-.088-.77-.117-1.152-.323-3.593-.147-7.252-1.071-10.758a3.799 3.799 0 0 0-1.298-2.024c-.733-.58-1.364-.58-2.398-.205a3.74 3.74 0 0 0-2.149 2.853c-.128.947-.18 1.904-.154 2.86a5.486 5.486 0 0 1-.55 2.2.183.183 0 0 0 .059.242c.47.278.91.586 1.313.938Z",
    fill: "#FF8257"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.77 23.46a3.234 3.234 0 1 0 0-6.468 3.234 3.234 0 0 0 0 6.468Z",
    fill: "#A5F9E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inbox_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.666 .664)",
    d: "M0 0h36.667v36.667H0z"
  })))));
};
export default SvgInbox;